<script setup>

import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import {defineProps, defineEmits, computed, ref, watch, onMounted} from 'vue';
import {useStore} from "vuex";

const props = defineProps({
  modelValue: Object,
  sourceCurrency : Object,
  id: String
});
const emit = defineEmits(['update:modelValue']);
const store = useStore()
const boxes = ref([]);
const accounts = computed(() => store.getters['accounts/getAccounts'])
const currentCompany = Ls.get('current.company')

const formData = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

watch(() =>  formData.value.payment_account_type, (value) => {
  if(value === 'account'){
    formData.value.box_id = ""
  }else{
    formData.value.account_id =  ""
  }
})

async function loadAccount () {
  await store.dispatch('accounts/loadAccountsForCountry',currentCompany)
}
async function loadBox () {
  await store.dispatch('accounts/loadSocietyBoxes').then((response) => {
    boxes.value = response.data.data
  })
}
const currencies = computed(() => store.getters['currencies/getCurrencies'])

const selectedCurrency = computed(() => {
  if(formData.value.payment_account_type === 'account'){
    let account =  Object.values(accounts.value)?.find(x => x.id === formData.value.account_id)
    return currencies.value?.find(x => x.id === account?.currency_id)
  }
  if(formData.value.payment_account_type === 'box'){
    let box =  boxes.value?.find(x => x.id === formData.value.box_id)
    return currencies.value?.find(x => x.id === box?.currency_id)
  }
  return ''
})

const displayExchangeInput = computed(() => selectedCurrency.value?.id && props.sourceCurrency && props.sourceCurrency?.id !== selectedCurrency.value?.id)


onMounted(() => {
  formData.value.payment_account_type = 'account'
  loadAccount()
  loadBox()
})

</script>

<template>
  <h5>{{$t('invoices.select_account_box')}}</h5>

  <div class="flex items-center gap-6 mb-10 mt-15">
    <label class="form-label flex items-center gap-2.5 text-nowrap me-5">
      <input
          class="radio me-3"
          name="radio2"
          type="radio"
          value="account"
          style="transform: scale(1.5);"
          v-model="formData.payment_account_type"
      />
      <span class="sub"> {{$t('invoices.account')}}</span>
    </label>
    <label class="form-label flex items-center gap-2.5 text-nowrap">
      <input
          class="radio me-3"
          name="radio2"
          type="radio"
          value="box"
          style="transform: scale(1.5);"
          v-model="formData.payment_account_type"
      />
      <span class="sub">  {{$t('invoices.box')}}</span>
    </label>
  </div>


  <Select2
      v-show="formData.payment_account_type === 'account'"
      container-class="form-group col-12 col-md-8 col-lg-8 mb-7"
      :multiple="false"
      :show-search="true"
      :selectClass="'form-select form-control-sm form-select-solid'"
      :name="'account-other'+id"
      :is-required="formData.payment_account_type === 'account'"
      :label="$t('invoices.select_account')"
      labelClass="form-label fs-6 text-black"
      :placeholder-text="$t('invoices.select_account')"
      v-model="formData.account_id"
      :parent-id="'#'+id"
  >
    <option v-for="account in accounts" :key="account.id" :value="account.id">
      {{ account.name }}
    </option>
  </Select2>

  <Select2
      v-show="formData.payment_account_type === 'box'"
      container-class="form-group col-12 col-md-8 col-lg-8 mb-7"
      :multiple="false"
      :show-search="true"
      :selectClass="'form-select form-control-sm form-select-solid'"
      :name="'box-other'+id"
      :is-required="formData.payment_account_type === 'box'"
      :label="$t('invoices.select_box')"
      labelClass="form-label fs-6 text-black"
      :placeholder-text="$t('invoices.select_box')"
      v-model="formData.box_id"
      :parent-id="'#'+id"
  >
    <option v-for="box in boxes" :key="box.id" :value="box.id">
      {{ box.name }}
    </option>
  </Select2>
  <Input
      v-if="displayExchangeInput"
      containerClass="col-12 col-md-8 col-lg-8"
      name="invoice-exchange"
      type="text"
      :label="$t('invoice.label.exchange')"
      labelClass="form-label fs-6 text-black"
      :inputClass="'form-control form-control-sm form-control-solid'"
      :isRequired="true"
      size="lg"
      :placeholder="$t('invoice.placeholder.exchange')"
      v-model="formData.exchange_rate"
      :IsInputGroup="true"
      addon-class="border-0 border-end"
      iconDir="left"
      :iconText="'1 '+ sourceCurrency?.iso +' ='">
    <template #rightAddon>
                  <span class="position-absolute end-0 top-50 translate-middle-y me-3 text-muted fw-bolder">
                    {{ selectedCurrency?.symbol }}
                  </span>
    </template>
  </Input>

</template>

<style scoped>

</style>